<template>
  <div>
    <Modal v-if="show" :show="show" @close="show = false">
      <div class="component">
        <h5 class="component-title">{{ modalTitle }}</h5>
        <div class="component-body">
          <ul class="list-unstyled language-options">
            <li
              class="language-option"
              v-for="(region, key) in allRegions"
              :key="key"
              :class="key === currentRegion ? 'active' : ''"
              @click="changeRegion(key)"
            >
              {{ region.label }}
            </li>
          </ul>
        </div>
        <div class="component-body-second" v-if="isLoggedIn">
          <label for="defaultRegion">Default region:</label>
          <multiselect
            id="defaultRegion"
            :value="defaultRegion"
            :options="defaultRegions"
            :close-on-select="true"
            :show-labels="false"
            :allowEmpty="false"
            placeholder="Select your default region"
            @input="updateDefaultRegion"
          ></multiselect>
        </div>
        <div class="component-button">
          <input
            type="button"
            class="btn btn-outline-primary"
            value="Continue"
            @click="clickedCancel"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "ChangeRegionModal",
  props: {
    modalTitle: String,
    allRegions: Object,
    currentRegion: String
  },
  data() {
    return {
      show: true
    };
  },
  computed: {
    ...mapState("brain", ["defaultRegion"]),
    ...mapGetters("brain/auth", ["isLoggedIn"]),

    defaultRegions() {
      return Object.keys(this.allRegions).map(key => {
        return this.allRegions[key].label;
      });
    }
  },
  methods: {
    changeRegion(region) {
      this.show = false;
      this.$emit("changeRegion", region);
    },
    clickedCancel() {
      this.show = false;
    },
    updateDefaultRegion(region) {
      this.$store.dispatch("brain/setDefaultRegion", region);
    }
  }
};
</script>

<style lang="scss" scoped>
.component {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }
  .component-body {
    margin: 24px 0;

    .language-options {
      margin: 0;
      .language-option {
        cursor: pointer;
        margin-bottom: 2px;

        &.active {
          color: $blue;
          cursor: default;
        }
      }
    }
  }
  .component-body-second {
    margin-top: 0;
    margin-bottom: 30px;
  }
  .component-button {
    margin-top: auto;
    display: flex;
    input {
      width: 100%;
      margin: 0 20px 0 0;
      &:last-of-type {
        margin: 0;
      }
    }
  }
}
</style>
